module.exports = __webpack_public_path__ + "static/media/mandate.65ed55c8.svg";